import React, { Component } from "react";
import StandardClockPreview from './standard'
import ClassicClockPreview from './classic'

class ClockPreview extends Component {


  render() {
    const { timeLayout } = this.props;

    return timeLayout == 0 ? <ClassicClockPreview  {...this.props} /> : timeLayout == 1 ? <StandardClockPreview {...this.props} /> : null
  }
}

export default ClockPreview
